var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitecopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(-5051 -5677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1054",
    "data-name": "Rectangle 1054",
    width: 32,
    height: 32,
    transform: "translate(5051 5677)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8e73d24d4cb9d5708c8d4a209f54a6bd",
    "data-name": "8e73d24d4cb9d5708c8d4a209f54a6bd",
    d: "M25.8,3h-9.77A6.533,6.533,0,0,0,9.513,9.513,6.533,6.533,0,0,0,3,16.027V25.8a6.533,6.533,0,0,0,6.513,6.513h9.77A6.533,6.533,0,0,0,25.8,25.8a6.533,6.533,0,0,0,6.513-6.513V9.513A6.533,6.533,0,0,0,25.8,3ZM22.54,25.8a3.266,3.266,0,0,1-3.257,3.257H9.513A3.266,3.266,0,0,1,6.257,25.8v-9.77A3.266,3.266,0,0,1,9.513,12.77h9.77a3.266,3.266,0,0,1,3.257,3.257Zm6.513-6.513A3.266,3.266,0,0,1,25.8,22.54V16.027a6.533,6.533,0,0,0-6.513-6.513H12.77a3.266,3.266,0,0,1,3.257-3.257H25.8a3.266,3.266,0,0,1,3.257,3.257Z",
    transform: "translate(5049.345 5675.345)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitecopy);
export default __webpack_public_path__ + "static/media/whitecopy.a47f446432fe508b1fdcc35ccf49438e.svg";
export { ForwardRef as ReactComponent };